import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

// Piccola etichetta con la revisione corrente del portale, mostrata nel footer.
export default function VersionTag({ className = "" }) {
  const [v, setV] = useState(null);
  useEffect(() => { api.get("/version").then(({ data }) => setV(data)).catch(() => {}); }, []);
  if (!v?.revision) return null;
  return (
    <div data-testid="version-tag" className={`pb-20 pt-2 text-center text-[11px] text-forest/40 md:pb-4 ${className}`}>
      Portale Partner Assietica · rev. {v.revision}{v.date ? ` del ${v.date}` : ""}
    </div>
  );
}
